<div class="loader-cont">
	<img class="loading-logo" src="assets/svg/spinner-icon.svg" alt="" />
	<span class="loader"></span>
</div>
